import PaymentCustomerInformation from "./PaymentCustomerInformation";

export default PaymentCustomerInformation;
